(function() {

function StadatView(utils, i18n, routing)
{
    this.dataFileUrl = 'stadat.json';

    this.utils = utils;
    this.i18n = i18n;
    this.routing = routing;
    
    this.loaded = null;
}

StadatView.prototype.getRoutes = function()
{
    return [{
        name: 'stadat_index',
        pattern: '/stadat/:lang:',
        defaults: { rendezes: 'tablaszam', sorrend: 'novekvo' }
    },{
        name: 'stadat_topic',
        pattern: '/stadat/tema/{topic}/:lang:',
        defaults: { rendezes: 'tablaszam', sorrend: 'novekvo' }
    },{
        name: 'stadat_tag',
        pattern: '/stadat/cimke/{tag}/:lang:',
        defaults: { rendezes: 'tablaszam', sorrend: 'novekvo' }
    },{
        name: 'stadat_calendar_index',
        pattern: '/stadat/naptar/:lang:'
    },{
        name: 'stadat_calendar',
        pattern: '/stadat/naptar/{year}/{month}/:lang:',
        defaults: {
            year: function() { return ''+(new Date()).getFullYear(); },
            month: function() { return ('0'+((new Date()).getMonth()+1)).slice(-2); }
        },
        rules: {
            year: /^[0-9]{4}$/,
            month: /^[0-9]{2}$/
        }
    }];
};

StadatView.prototype.handleRequest = function(params, render)
{
    var fileUrls = {
            'L': {
                'hu': 'docs/hun/xstadat/xstadat_hosszu',
                'en': 'docs/eng/xstadat/xstadat_long'
            },
            'Y': {
                'hu': 'docs/hun/xstadat/xstadat_eves',
                'en': 'docs/eng/xstadat/xstadat_annual'
            },
            'M': {
                'hu': 'docs/hun/xstadat/xstadat_evkozi',
                'en': 'docs/eng/xstadat/xstadat_infra'
            }
        };
    
    if (!this.loaded) {
        var that = this;
        
        this.utils.loadDataFile(this.dataFileUrl)
        .done(function(data){
            var releases = data;
            
            for (var i = 0, n = releases.length; i < n; ++i) {
                releases[i].fileurl = fileUrls[releases[i].catid];
                releases[i].tableno = releases[i].tableno.replace(/^[0-9.\r\n]+(\n| )/, ''); // DEV ONLY
            }
            that.loaded = that.utils.initData(releases);
            that.renderResponse(params, render);
        })
        .fail(function(){
            console.log(arguments);
        });
    } else {
        this.renderResponse(params, render);
    }
};

StadatView.prototype.renderResponse = function(params, render)
{

    var lang = this.i18n.lang,
        data = this.loaded.data,
        context = {
            _menu: 'stadat'
        };
    
    switch (params._route) {
        case 'stadat_index':
            
            var items = [];
            for (var i = 0, n = data.length; i < n; ++i) {
                if (!params.kategoria || data[i].xCatRevMap[lang][params.kategoria]) {
                    items.push(data[i]);
                }
            }
            
            if (params.rendezes) {
                this.sort(items, params.rendezes, params.sorrend);
            }
            
            context.catalog_title = this.i18n.trans('catalog.all_topics');
            context.items = items;
            context.topics = this.loaded.topics[lang];
            context.categories = this.loaded.categories[lang];
            
            this.utils.addFilters(context, params);
            
            render('stadat/catalog.html', context);
            
            this.addListEventListeners();
            
            this.utils.itemAutoLoader('#catalog-list ul', 'stadat/list_item.html', context, context.items).load();
            
            break;
        case 'stadat_topic':
            
            var items = [];
            for (var i = 0, n = data.length; i < n; ++i) {
                if (
                    data[i].xTopicsRevMap[lang][params.topic]
                    && (!params.kategoria || data[i].xCatRevMap[lang][params.kategoria])
                ) {
                    items.push(data[i]);
                }
            }
            
            if (params.rendezes) {
                this.sort(items, params.rendezes, params.sorrend);
            }
            
            context.catalog_title = this.loaded.topics[lang].urlRevMap[params.topic];
            context.items = items;
            context.topics = this.loaded.topics[lang];
            context.categories = this.loaded.categories[lang];
            
            this.utils.addFilters(context, params);
            
            render('stadat/catalog.html', context);
            
            this.addListEventListeners();
            
            this.utils.itemAutoLoader('#catalog-list ul', 'stadat/list_item.html', context, context.items).load();
            
            break;
        case 'stadat_tag':
            
            var items = [];
            for (var i = 0, n = data.length; i < n; ++i) {
                if (
                    data[i].xTagsRevMap[lang][params.tag]
                    && (!params.kategoria || data[i].xCatRevMap[lang][params.kategoria])
                ) {
                    items.push(data[i]);
                }
            }
            
            if (params.rendezes) {
                this.sort(items, params.rendezes, params.sorrend);
            }
            
            context.catalog_title = this.i18n.trans('catalog.tag_title', { tag: this.loaded.tags[lang].urlRevMap[params.tag] });
            context.items = items;
            context.topics = this.loaded.topics[lang];
            context.categories = this.loaded.categories[lang];
            
            this.utils.addFilters(context, params);
            
            render('stadat/catalog.html', context);
            
            this.addListEventListeners();
            
            this.utils.itemAutoLoader('#catalog-list ul', 'stadat/list_item.html', context, context.items).load();
            
            break;
        case 'stadat_calendar_index':
            params.year = ''+(new Date()).getFullYear();
            params.month = ('0'+((new Date()).getMonth()+1)).slice(-2);
        
        case 'stadat_calendar':
            
            var formats = this.utils.dateFormats[lang];
            for (var k in formats) {
                context[k] = formats[k];
            }
            
            // act, prev, next
            var act = new Date(parseInt(params.year, 10), parseInt(params.month)-1, 1),
                prev = new Date(act),
                next = new Date(act);
            
            prev.setMonth(prev.getMonth()-1);
            next.setMonth(next.getMonth()+1);
            
            context.calendar_act = act;
            
            if (act > this.loaded.minDate) {
                context.calendar_prev = prev;
            }
            
            if (next < this.loaded.maxDate) {
                context.calendar_next = next;
            }
            
            // items.
            var days = [], daysOffsetMap = {};

            var startDay = new Date(act),
                endDay = new Date(next);
            
            // a hetek nem vasárnappal kezdődnek, hanem hétfővel.
            // ha vasárnap van akkor ugrás az előző hétre
            if (startDay.getDay() === 0) startDay.setDate(startDay.getDate() - 6);
            // a hét első napjára ugrunk
            startDay.setDate((startDay.getDate() - startDay.getDay()) + 1);
            
            // a hetek nem vasárnappal kezdődnek, hanem hétfővel.
            // ha vasárnap van akkor ugrás az előző hétre
            if (endDay.getDay() === 0) endDay.setDate(endDay.getDate() - 6);
            // a hét utolsó napjára ugrunk
            endDay.setDate((endDay.getDate() - endDay.getDay()) + 7);
            
            var day = new Date(startDay), thisMonth = act.format('m');
            while (day <= endDay) {
                daysOffsetMap[day.format('Ymd')] = days.length;
                days.push({ date: new Date(day), outer: thisMonth !== day.format('m'), hasReleased: false, items: [] });
                day.setDate(day.getDate() + 1);
            }
            
            var dayObj
            for (var i = 0, n = data.length; i < n; ++i) {
                for (var j = 0, m = data[i].xReleaseDates.length; j < m; ++j) {
                    if (startDay <= data[i].xReleaseDates[j] && data[i].xReleaseDates[j] <= endDay) {
                        dayObj = days[daysOffsetMap[data[i].xReleaseDates[j].format('Ymd')]];
                        if (data[i].released) {
                            dayObj.hasReleased = true;
                        }
                        dayObj.items.push(data[i]);
                    }
                }
            }
            
            // :TODO: sajnos ez a rendezés költséges, optimalizálni kellene
            for (var i = 0, n = days.length; i < n; ++i) {
                // azért így és nem items.sort(cmpReleaseAsc) mert így nem kell definiálni újra a cmpReleaseAsc függvényt.
                // persze lehetne egy getCompare metódust írni majd vmikor, de az kb ugyan ez lenne a végülis.
                this.sort(days[i].items, 'tablaszam', 'növekvo');
            }
            
            context.days = days;
            context.topics = this.loaded.topics;
            
            render('stadat/calendar.html', context);
            
            this.addCalendarEventListeners();
            
            break;
        default:
            context.error_text = this.i18n.trans('error.unexpected_error');
            render('error.html', context);
    }
};

StadatView.prototype.sort = function(items, sortby, order)
{
    var lang = this.i18n.lang;

    function cmpTableNoAsc(a, b)
    {
        return natural_sort_compare_chunks(
            natural_sort_chunkify(a.tableno),
            natural_sort_chunkify(b.tableno)
        );
    }
    
    function cmpTableNoDesc(a, b)
    {
        return natural_sort_compare_chunks(
            natural_sort_chunkify(b.tableno),
            natural_sort_chunkify(a.tableno)
        );
    }
    
    function cmpNameAsc(a,b)
    {
        return a.xSortTitle[lang] === b.xSortTitle[lang]
            ? (a.released === b.released
                ? a.xReleaseDate - b.xReleaseDate
                : a.released ? -1 : 1)
            : a.xSortTitle[lang].localeCompare(b.xSortTitle[lang])
        ;
    }

    function cmpNameDesc(a,b)
    {
        return a.xSortTitle[lang] === b.xSortTitle[lang]
            ? (a.released === b.released
                ? a.xReleaseDate - b.xReleaseDate
                : a.released ? -1 : 1)
            : b.xSortTitle[lang].localeCompare(a.xSortTitle[lang])
        ;
    }

    function cmpReleaseAsc(a,b)
    {
        return a.xReleaseDate == b.xReleaseDate
            ? (a.released === b.released
                ? a.xSortTitle[lang].localeCompare(b.xSortTitle[lang])
                : (a.released ? -1 : 1)
            )
            : a.xReleaseDate - b.xReleaseDate
        ;
    }

    function cmpReleaseDesc(a,b)
    {
        return a.xReleaseDate == b.xReleaseDate
            ? (a.released === b.released
                ? a.xSortTitle[lang].localeCompare(b.xSortTitle[lang])
                : (a.released ? -1 : 1)
            )
            : b.xReleaseDate - a.xReleaseDate
        ;
    }

    var cmp;
    if (sortby === 'cim') {
        cmp = order === 'csokkeno' ? cmpNameDesc : cmpNameAsc;
    } else if (sortby === 'tablaszam') {
        cmp = order === 'csokkeno' ? cmpTableNoDesc : cmpTableNoAsc;
    } else {
        cmp = order === 'csokkeno' ? cmpReleaseDesc : cmpReleaseAsc;
    }
    items.sort(cmp);
};

StadatView.prototype.addListEventListeners = function()
{
    var routing = this.routing;
    
    var categorySel = $('#categories-select');
    categorySel.on('change', function()
    {
        var val = categorySel.val();
        if (val === '') {
            delete routing.last.kategoria;
        } else {
            routing.last.kategoria = val;
        }
        routing.setRoute(routing.last._route, routing.last);
    });
    
    var sort_sel = $('#sort-select');
    sort_sel.on('change', function()
    {
        var split = sort_sel.val().split('/');
        routing.last.rendezes = split[0];
        routing.last.sorrend = split[1];
        routing.setRoute(routing.last._route, routing.last);
    });
    
    $('#btn-open-all').on('click', function()
    {
        $('#catalog-list > ul').addClass('open-all');
        $('#catalog-list > ul > li').each(function()
        {
            this.className = 'open';
        });
    });
    
    $('#btn-close-all').on('click', function()
    {
        $('#catalog-list > ul').removeClass('open-all');
        $('#catalog-list > ul > li').each(function()
        {
            this.className = '';
        });
    });
    
    $('#catalog-list').on('click', '.pub-header', function(evt)
    {
        $(evt.target).closest('li').toggleClass('open');
    });
};

StadatView.prototype.addCalendarEventListeners = function()
{
    $('#calendar-list .pub-header').on('click', function()
    {
        $(this).parent().toggleClass('open');
    });
    
    $('#calendar-days tbody td.has-item').on('click', function()
    {
        var $this = $(this);
        $('#calendar-days tbody td.active').removeClass('active');
        $this.addClass('active');
        $('#calendar-list > ul').hide().find('li.open').removeClass('open');
        $('#'+$this.data('list')).show();
    });
        
    var today = this.utils.now.format('Ymd'),
        todayItem = $('#calendar-days tbody td.has-item[data-list="list-'+today+'"] :not(.outer)');
    
    if (todayItem.length > 0) {
        todayItem.click();
    } else {
        $('#calendar-days tbody td.has-item :not(.outer)').first().click();
    }
};

window.StadatView = StadatView;

})();